import ContinueWatchingListItem from './ContinueWatchingListItem';

export default ContinueWatchingListItem;
